import axiosInstance from "../../../common/axiosInstance";

export const updateProject = async (projectUuid, projectData) => {
  try {
    const response = await axiosInstance.put(
      `/projects/${projectUuid}`,
      projectData
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update project"
    );
  }
};